import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PatientDetails } from '../../components/common/patientDetails';

import {
    fetchPendingCounsellingPatientsData,
    updateCounsellingStatus
} from '../../services/slices/supervisor/pendingCounselling';

import {
    Loader,
    LoadingView
} from '../../components/common/loader';

import { DispenseRxData } from '../../components/common/dispenseRxData';
import { useAuthSelector } from '../../services/selectors/authSelector';

import { useCustomStates } from '../../hooks/useCustomStates';
import { useCustomDispatch } from '../../hooks';

import { useSuperVisorSelector } from '../../services/selectors/allSuperVisorSelector';
import { ErrorMessages } from '../../components/error/errorMessages';

import * as routeNames from '../../routes/routeName';
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';

// Extracted Patient Counselling Card Component
const PatientCounsellingCard = ({ data,
    index,
    openIndex,
    handleDropdownToggle,
    updateCounsellingStatusResponse,
    setOpenIndex }) => {

    const isOpen = openIndex === index;
    const [newRxCounsellingValues, setNewRxCounsellingValues] = useState([]);
    const [isCounsellingValues, setIsCounsellingValues] = useState(false);

    const { pharmacyId } = useAuthSelector();
    const dispatch = useCustomDispatch();
    const [selectedDoses, setSelectedDoses] = useState({})

    const handleUpdateCounselling = () => {
        const isCounsellingValues = newRxCounsellingValues?.every(entry => entry?.dropdownValue?.value);
        if (isCounsellingValues) {
            setIsCounsellingValues(false);
            dispatch(updateCounsellingStatus({
                pharmacyId: pharmacyId,
                newRxCounsellingValues: newRxCounsellingValues,
                dispatch
            })).finally(() => {
                setOpenIndex(null);
            })
        } else {
            setIsCounsellingValues(true);
        }
    }

    return (
        <div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
            <PatientDetails
                index={index}
                data={data}
                totalRxData={data?.patients_win_rx_data?.length}
                openIndex={openIndex}
                onDropdownToggle={handleDropdownToggle}
            >
                <DispenseRxData
                    rxData={data?.patients_win_rx_data}
                    patientData={data}
                    pending_counselling={true}
                    type="pending_counselling_rxes"
                    newRxCounsellingValues={newRxCounsellingValues}
                    setNewRxCounsellingValues={setNewRxCounsellingValues}
                    selectedDoses={selectedDoses}
                    setSelectedDoses={setSelectedDoses}
                />
                <div className='mt-2'>
                    {isCounsellingValues ? <p className='text-red-700 font-medium text-sm'>Please select counselling values</p> : null}
                    <button onClick={handleUpdateCounselling} className='px-4 flex-1 py-2 bg-[#10b981] flex items-center justify-center 
                        text-white rounded-md w-full'>
                        {updateCounsellingStatusResponse?.loading ? <Loader /> : 'Confirm'}
                    </button>
                </div>
            </PatientDetails>
        </div>
    );
};

const PendingCounselling = () => {

    const navigate = useNavigate();
    const dispatch = useCustomDispatch();

    const { pharmacyId } = useAuthSelector();
    const { pendingCounsellingResponse } = useSuperVisorSelector();

    const pendingPatients = pendingCounsellingResponse?.patients?.data?.data;
    const pendingPatientsLoading = pendingCounsellingResponse?.patients?.loading;
    const pendingPatientsError = pendingCounsellingResponse?.patients?.error;

    const updateCounsellingStatusResponse = pendingCounsellingResponse?.updateStatus;

    const { openIndex, setOpenIndex, setShowData } = useCustomStates();

    const handleDropdownToggle = (index, data) => {
        if (openIndex === index) {
            setOpenIndex(null);
        } else {
            setOpenIndex(index);
        }
        setShowData(false);
        setTimeout(() => {
            const nextPatientCard = document.getElementById(`patientCard-${index}`);
            if (nextPatientCard) {
                nextPatientCard.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100);
    };

    useEffect(() => {
        dispatch(fetchPendingCounsellingPatientsData({
            pharmacyId: pharmacyId
        }))
    }, [pharmacyId])

    return (
        <div className="app-wrapper flex justify-center">
            <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
                <div className="relative p-4" >
                    <Common.TopBar />

                    <div className="title-row my-2" >
                        <h1 className="text-xl font-bold">Pending Counselling</h1>
                    </div>

                    {pendingPatientsLoading ?
                        <div className='h-96 flex justify-center'>
                            <LoadingView />
                        </div>
                        :
                        pendingPatientsError !== null ?
                            <div className='flex  justify-center pb-4 mb-4 '>
                                <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                            </div>
                            :
                            pendingPatients?.length === 0 ?
                                <p className='flex  pb-4 pt-3 h-96'>
                                    No Records Found.
                                </p>
                                :
                                <div className="">
                                    {pendingPatients?.map((data, index) => (
                                        data?.patients_win_rx_data?.length === 0 || data?.patients_win_rx_data === null ? null :
                                            <PatientCounsellingCard
                                                updateCounsellingStatusResponse={updateCounsellingStatusResponse}
                                                key={index}
                                                data={data}
                                                index={index}
                                                setOpenIndex={setOpenIndex}
                                                openIndex={openIndex}
                                                handleDropdownToggle={handleDropdownToggle}
                                            />
                                    ))}
                                </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default PendingCounselling;
